import { inject } from "@angular/core";
import { ADD_MAIN_LINKS } from "../../layouts/config/sidenav.config";

export function provideSideNav() {
  inject(ADD_MAIN_LINKS);
}
